import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, useMediaQuery, Card, CardContent, CardActions, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider } from "@mui/material"
import Header from './Header'
import FlexBetween from './FlexBetween'
import { UserAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import TokenContext from '../context/TokenContext'
import { COLUMNSEVALUACIONESPENDIENTES, COLUMNSMISEVALUACIONESCOMPVEN } from '../columnas/columnasEvaluacion'
import { evaluacionPorId, evaluacionesPend, misEvaluacionesCompletadasVencidas } from '../Redux/evaluaciones'
import TablaEvaluaciones from './tablas/TablaEvaluaciones'
import ModalEvaluaciones from './modales/ModalEvaluaciones'

import CircularProgress from '@mui/material/CircularProgress';

const Evaluaciones = () => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const theme = useTheme()
    const { empleado } = UserAuth() //empleado contiene el usuarioPortalRh y empleadoid, esos dos valores son necesarios para las consultas a los fetch.
    const fechaHoy = new Date().toLocaleDateString()

    const [idEvaluacion, setIdEvaluacion] = React.useState('')

    const [openModal, setOpenModal] = React.useState(false);

    const [evaluacionPendiente, setEvaluacionPendiente] = React.useState([])

    const [loadPend, setLoadPend] = React.useState(false)
    const [evaluaciones, setEvaluaciones] = React.useState([])
    const [columnasEvaluaciones, setColumnasEvaluaciones] = React.useState(COLUMNSEVALUACIONESPENDIENTES)

    const [loadMisEv, setLoadMisEv] = React.useState(false)
    const [misEv, setMisEv] = React.useState([])
    const [columnasMisEv, setColumnasMisEv] = React.useState(COLUMNSMISEVALUACIONESCOMPVEN)

    const [itemsEv, setItemsEv] = React.useState([])

    const evaluacionesSelector = useSelector(store => store.evaluaciones.evaluacionesPendientes)
    const misEvaluacionesSelector = useSelector(store => store.evaluaciones.misEvaluacionesCompletadasVencidas)
    const evaluacionIdSelector = useSelector(store => store.evaluaciones.evaluacionId)
    const resultadoModificacion = useSelector(store => store.evaluaciones.modificacionEvaluacion)
    const loadingEvaluacionesPendientes = useSelector(store => store.evaluaciones.loadingEvaluacionesPendientes)
    const loadingMisEvaluaciones = useSelector(store => store.evaluaciones.loadingMisEvaluaciones)

    React.useEffect(() => {
        if (token) {
            dispatch(evaluacionesPend(token, fechaHoy, empleado.empleadoid))
            dispatch(misEvaluacionesCompletadasVencidas(token, empleado.empleadoid))
        }
    }, [token, empleado])

    React.useEffect(() => {
        setLoadPend(loadingEvaluacionesPendientes)
        setLoadMisEv(loadingMisEvaluaciones)
    }, [loadingEvaluacionesPendientes, loadingMisEvaluaciones])

    React.useEffect(() => {
        if (evaluacionesSelector.length > 0) {
            var array = []
            evaluacionesSelector.forEach(element => {
                var objeto = {
                    id: element.new_evaluacionid,
                    _new_evaluado_value: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeevaluacion: element["new_tipodeevaluacion@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadevencimiento: element["new_fechadevencimiento@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluador_value: element._new_evaluador_value,
                    new_evaluador: element["_new_evaluador_value@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name
                }
                array.push(objeto)
            });
            setEvaluaciones(array)
        }
    }, [evaluacionesSelector])

    React.useEffect(() => {
        if (misEvaluacionesSelector.length > 0) {
            var array = []
            misEvaluacionesSelector.forEach(element => {
                var objeto = {
                    id: element.new_evaluacionid,
                    new_valoracionfinal: element.new_valoracionfinal,
                    statuscode: element["statuscode@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluado_value: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeevaluacion: element["new_tipodeevaluacion@OData.Community.Display.V1.FormattedValue"],
                    _new_periodo_value: element["_new_periodo_value@OData.Community.Display.V1.FormattedValue"],
                    _new_materia_value: element["_new_materia_value@OData.Community.Display.V1.FormattedValue"],
                    new_fechadevencimiento: element["new_fechadevencimiento@OData.Community.Display.V1.FormattedValue"],
                    _new_evaluador_value: element._new_evaluador_value,
                    new_evaluador: element["_new_evaluador_value@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name
                }
                array.push(objeto)
            });
            setMisEv(array)
        }
    }, [misEvaluacionesSelector])

    React.useEffect(() => {
        if (evaluacionIdSelector.length > 0) {
            setItemsEv(evaluacionIdSelector)
        }
    }, [evaluacionIdSelector])

    React.useEffect(() => {
        if (resultadoModificacion !== undefined) {
            if (resultadoModificacion !== '' && resultadoModificacion == "EXITO") {
                dispatch(evaluacionesPend(token, fechaHoy))
                dispatch(misEvaluacionesCompletadasVencidas(token))
                setTimeout(() => {
                    handleCloseModal()
                }, 1000)
            }
        }
    }, [resultadoModificacion])

    //======|| handlers del modal evaluaciones pendientes ||====== //
    const handleCloseModal = () => {
        setOpenModal(false)
        setEvaluacionPendiente('')
        setItemsEv([])
    };

    const handleOpenModalPendientes = (id) => {
        setOpenModal(true);
        setIdEvaluacion(id)
        setEvaluacionPendiente(evaluaciones.filter((item) => item.id == id));
        dispatch(evaluacionPorId(token, id))
    };
    //======================================================= //

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Header title={"Evaluaciones Docentes"} subtitle="" />

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Mis Evaluaciones Pendientes de Completar
                            </Typography>
                        </Box>
                        {
                            loadPend ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            )
                                : evaluaciones.length > 0? (
                                    <TablaEvaluaciones columnas={columnasEvaluaciones} lineas={evaluaciones} handleOpen={handleOpenModalPendientes} acciones={true} />
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        Aún no tienes registros de evaluaciones — <strong>Pendientes</strong>.
                                    </Alert>

                        }
                    </Grid>

                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <Box sx={{ p: 2 }} display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Mis Evaluaciones Completadas y Vencidas
                            </Typography>
                        </Box>
                        {
                            loadMisEv ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                        py: 2
                                    }}>
                                    <CircularProgress color="secondary" />
                                </Box>
                            )
                                : misEv.length > 0 ? (
                                    <TablaEvaluaciones columnas={columnasMisEv} lineas={misEv} />
                                ) :
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        Aún no tienes registros de evaluaciones — <strong>Completadas y Vencidas</strong>.
                                    </Alert>

                        }
                    </Grid>
                </Grid>
            </Box>
            <ModalEvaluaciones open={openModal} handleClose={handleCloseModal} evaluacionPendiente={evaluacionPendiente[0]} itemsEvaluacion={itemsEv} idEvaluacion={idEvaluacion} />
        </motion.div>
    )
}

export default Evaluaciones